export default {
      id: "puce-usage",
      viewBox: "0 0 12 12",
      url: "../dist/images/" + "sprite.svg#puce-usage",
      toString: function () {
        return this.url;
      }
    }